import { Route, Switch, BrowserRouter } from "react-router-dom";

import DoobiHeader from "components/Headers/DoobiHeader";
import MonthlyPackage from "components/Doobi/MonthlyPackage";

const MonthlyPackageRoute = ({ match }) => {
  return (
    <>
      <DoobiHeader section="Monthly Package" />
      <BrowserRouter>
        <Switch>
          <Route path={`${match.path}/`} component={MonthlyPackage} />
        </Switch>
      </BrowserRouter>
    </>
  );
};

export default MonthlyPackageRoute;
